<div nz-row class="login-row"  >
    <div nz-col   nz-col nzXs="20" nzSm="16" nzMd="8" nzLg="6" nzXl="6"  class="login-col shadow">

            <div class="logo">
                <!-- <img  src="../../assets/images/S2S-RGB-big-BF.png" > -->

                <svg xmlns="http://www.w3.org/2000/svg" width="68" height="34" viewBox="0 0 68 34">
                  <rect id="Rectangle_11" data-name="Rectangle 11" width="31" height="34" fill="#4682A9"/>
                  <g id="Group_11" data-name="Group 11" transform="translate(-1425 -347)">
                    <line id="Line_10" data-name="Line 10" y2="13.5" transform="translate(1460.731 351.746)" fill="none" stroke="#4682A9" stroke-width="3"/>
                    <line id="Line_14" data-name="Line 14" x2="15" transform="translate(1459.731 353.246)" fill="none" stroke="#4682A9" stroke-width="3"/>
                    <line id="Line_16" data-name="Line 16" x2="15" transform="translate(1459.731 363.746)" fill="none" stroke="#4682A9" stroke-width="3"/>
                    <line id="Line_20" data-name="Line 20" y2="13.5" transform="translate(1473.241 362.246)" fill="none" stroke="#4682A9" stroke-width="3"/>
                    <line id="Line_22" data-name="Line 22" x1="15.019" transform="translate(1459.222 374.246)" fill="none" stroke="#4682A9" stroke-width="3"/>
                    <path id="Subtraction_1" data-name="Subtraction 1" d="M82.269-29h-4L69-39.976v-3.082l8.961-10.449h3.572L71.023-41.749,82.268-29Z" transform="translate(1408.731 405.253)" fill="#4682A9" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/>
                  </g>
                  <line id="Line_23" data-name="Line 23" x2="15" transform="translate(6.213 16.5)" fill="none" stroke="#fff" stroke-width="3"/>
                  <path id="Subtraction_3" data-name="Subtraction 3" d="M71.707-29H65.213v-5h2.871v2.4h3.657c3.2,0,5.723-.868,7.5-2.58s2.683-4.173,2.683-7.314c0-3.124-.842-5.5-2.5-7.062s-4.189-2.354-7.512-2.354H68.084V-49H65.213v-4.507H71.98c4.3,0,7.567,1,9.716,2.986s3.239,5,3.239,8.959a12.093,12.093,0,0,1-3.6,9.118A13.407,13.407,0,0,1,71.707-29Z" transform="translate(-59 57.753)" fill="#f4f4f5" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/>
                  <g id="Rectangle_12" data-name="Rectangle 12" transform="translate(29)" fill="none" stroke="#4682A9" stroke-width="1">
                    <rect width="39" height="34" stroke="none"/>
                    <rect x="0.5" y="0.5" width="38" height="33" fill="none"/>
                  </g>
                </svg>
                
                
                  
                <!-- <h1 >Desk</h1> -->
                <h3 style="margin-top: 10px;">Please sign in</h3>

                <p class="google-btn">
                    <asl-google-signin-button
                        type="standard" 
                        shape="square"
                        theme="filled_blue"
                        size="medium">
                    </asl-google-signin-button>
                </p>

                <p class="copy-rights">© 2026 BuyerForesight</p>

            </div>
        
    </div>
  </div>
